<template>
	<div>
		<div v-if="listData.visible !== false && listElements.length > 0">
			<b-button 	class="vrnu-button"
						v-on:click="addElement"><span class="icon-plus-circled"></span>&nbsp;&nbsp;{{ listData.name }} hinzufügen</b-button>
			<div class="space30"></div>
			<div class="my-1 row">
				
				<!-- Pagination count -->
				<div v-if="listData.pagination == true" class="col-md-6">
					<b-form-group 	horizontal
									label="Einträge pro Seite"
									v-bind:label-cols="6">
						<b-form-select 
									v-bind:options="pageOptions"
									v-model.trim="perPage" />
					</b-form-group>
				</div>
				
				<!-- Filter -->
				<div v-if="listData.filter == true" class="col-md-6">
					<b-form-group 	horizontal
									label="Suche"
									v-bind:label-cols="3">
						<b-input-group>
							<b-form-input v-model.trim="filter" placeholder="Suchbegriff" style="height: 38px;"/>
							<b-input-group-append>
								<b-btn :disabled="!filter" @click="filter = ''">Löschen</b-btn>
							</b-input-group-append>
					</b-input-group>
					</b-form-group>
				</div>
			</div>

			<!-- The table -->		
			<b-table 	striped
						hover
						responsive
						v-bind:items="listElements"
						v-bind:fields="listData.fields"
						v-bind:per-page="perPage"
						v-bind:currentPage="currentPage"
						v-bind:filter="filter"
						class="list-table">
				<template v-slot:cell(actions)="data" v-bind:slot-scope="listData"> <!-- v-bind:slot-scope="listData" -->
					<span 	v-for="(action, key) in listData.actions"
							v.bind:key="key">
						<button v-if="action.type == 'view'"
								v-on:click="viewElement(data.item._id)"
								class="action-button"
								v-b-tooltip.hover
								v-bind:title="action.text">
							<span v-bind:class="action.icon"></span>
						</button>
						<button v-else-if="action.type == 'delete'"
								v-on:click="confirmDeleteElement(data.item)"
								class="action-button"
								v-b-tooltip.hover
								v-bind:title="action.text">
							<span v-bind:class="action.icon"></span>
						</button>
						<button v-else-if="action.type == 'custom'"
								v-on:click="emitValue(action.emit, data.item._id)"
								class="action-button"
								v-b-tooltip.hover
								v-bind:title="action.text">
							<span v-bind:class="action.icon"></span>
						</button>
						<button v-else-if="action.type == 'update'"
								v-on:click="updateElement(data.item._id)"
								class="action-button"
								v-b-tooltip.hover
								v-bind:title="action.text">
							<span v-bind:class="action.icon"></span>
						</button>
					</span>
				</template>
			</b-table>
			
			<!-- Pagination pages -->
			<div v-if="listData.pagination == true" class="row my-1">
				<div class="col-sm-8">
					<b-pagination :total-rows="totalRows" :per-page="perPage" v-model.trim="currentPage" />
				</div>
				<!--  <div class="col-sm-4 text-md-right">
					<b-button :disabled="!sortBy" @click="sortBy = null">Sortierung zurücksetzen</b-button>
				</div> -->
			</div>			
		</div>
		<div v-if="listElements.length == 0">
			<p class="text-center">
				In dieser Ansicht sind keine Elemente vorhanden.<br>Fügen Sie jetzt den ersten Eintrag hinzu!
				<br><br>
				<b-button v-on:click="addElement" class="vrnu-button"><span class="icon-plus-circled"></span>&nbsp;&nbsp;{{ listData.name }} hinzufügen</b-button>
			</p>
		</div>
		
		<!-- Form modal -->
		<b-modal ref="formModal" size="lg" centered hide-footer v-bind:title="listData.name + ' ' + actionName" v-on:hidden="formModalHidden">
			<component 	v-if="showFormComponent"
						v-bind:is="listData.formModule"
						v-bind:formData="listData.name + ' ' + actionName"
						v-bind:updateId="updateId"
						v-on:closeModal="closeModalAndRefresh('formModal')"
						v-on:saveSuccess="saveSuccess"
						v-on:saveError="saveError"></component>
	    </b-modal>	    

		<!-- View modal -->
		<b-modal ref="viewModal" size="lg" centered hide-footer v-bind:title="listData.name + ' ' + actionName" v-on:hidden="viewModalHidden">
			<component 	v-if="viewItemId !== null"
						v-bind:is="listData.viewModule"
						v-bind:objectId="viewItemId"
						v-on:closeModal="closeModalAndRefresh('viewModal')"></component>
	    </b-modal>	    
	    	    
	    <!-- Confirm modal -->
		<b-modal ref="confirmModal" centered hide-footer v-bind:title="listData.name + ' ' + actionName">
			<p>{{ listData.name }} "{{ (confirmItem !== null) ? (confirmItem[listData.confirmAttribute]) : ('') }}" {{ actionName }}?</p>
			<slot name="modal-ok">
				<b-button class="vrnu-button" v-on:click="deleteElement">Ok</b-button>
			</slot>
			<slot name="modal-cancel">
				<b-button v-on:click="$refs.confirmModal.hide()">Abbrechen</b-button>
			</slot>
	    </b-modal>	    
	</div>
</template>

<script>
/*
 * PROBLEMS:
	 # Load entries of other pages only when the user switches to the respective page
	 # Filter function of entries on THE SERVER
	 # Reload list when an item is added on the server (process)?
 */

export default {
	data: function() {
		return {
			actionName: null,
			confirmItem: null,
			viewItemId: null,
			updateId: null,
			listElements: [],
			filter: null,
			perPage: (this.listData.pagination === true) ? (10) : (null),
			currentPage: 1,
			totalRows: null,
			sortBy: false,
			showFormComponent: true,
			pageOptions: [
				{text: 5, value: 5},
				{text: 10, value: 10},
				{text: 15, value: 15},
				{text: 20, value: 20},
				{text: 25, value: 25},
				{text: 30, value: 30},
			],
		};
	},
	computed: {
	},
	methods: {
		addElement: function() {
			// Show modal
			this.actionName = 'anlegen';
			this.updateId = null;
			this.showFormComponent = true;
			this.$refs.formModal.show();
		},
		updateElement: function(id) {
			// Show modal
			this.actionName = 'bearbeiten';
			this.updateId = id;
			this.showFormComponent = true;
			this.$refs.formModal.show();
		},
		viewElement: function(id) {
			// Show modal
			this.viewItemId = id;
			this.actionName = 'anzeigen';
			this.$refs.viewModal.show();
		},
		confirmDeleteElement: function(item) {
			// Open notification modal
			this.actionName = 'löschen';
			this.confirmItem = item;
			this.$refs.confirmModal.show();			
		},
		deleteElement: function() {
			var id = this.confirmItem._id;
			this.$emit('delete', id);
			this.closeModalAndRefresh('confirmModal');			
		},
		closeModalAndRefresh: function(modalRef) {
			this.$refs[modalRef].hide();
			this.refreshList();
		},
		viewModalHidden: function() {
			// If the viewModal is closed, destroy the child component
			this.viewItemId = null;
		},
		formModalHidden: function() {
			// If the formModal is closed, destroy the child component
			this.showFormComponent = false;			
		},
		saveSuccess: function(result) {
			this.$emit('saveSuccess', result);
		},
		saveError: function(response) {
			this.$emit('saveError', response);
		},
		emitValue: function(value, id) {
			this.$emit(value, id);
		},
		getDataFromResource: function(target) {
			// Get elements from defined resource
			if(typeof(target) == 'string') {
				this.$http.get(target).then(function(response) {
					// Request succesful
					this.listElements = response.body;
					this.totalRows = this.listElements.length;
				}, function(response) {
					// Request failed
					console.log(response);				
				});
			}
		},
		addActionsColumn: function() {
			if(Array.isArray(this.listData.fields) && Array.isArray(this.listData.actions)) {
				this.listData.fields.push({
					key: 'actions',
					label: 'Aktionen',
					sortable: false,
				});
			}
		},
		refreshList: function() {
			this.getDataFromResource(this.listData.target);
			this.addActionsColumn();			
		},
	},
	mounted: function() {
		this.refreshList();
	},
	props: {
		listData: {
			required: true,
		}
	}
}
</script>

<style>
.text-green {
	color: green;
}
.text-red {
	color: red;
}
.font-big {
	font-size: 1.2rem;
}
.action-button {
  width: 32px;
  height: 32px;
	background: #334455;
	border: 1px solid #334455;
	color: white;
	margin: 0px 5px 5px 0px;
	-webkit-border-radius: 3px;
	-moz-border-radius: 3px;
	border-radius: 3px;
}
.action-button:HOVER {
	background: #FF6600;
	border: 1px solid #FF6600;
	cursor: pointer;
	
	-webkit-transition: all 0.2s ease-in; /* Firefox */
	-moz-transition: all 0.2s ease-in; /* WebKit */
	-o-transition: all 0.2s ease-in; /* Opera */
	transition: all 0.2s ease-in; /* Standard */
}
</style>



// WEBPACK FOOTER //
// src/components/99_wizards/ListWizard.vue